import React, { useState } from "react";

type Props = {
  onClose?: () => void;
};

const ContactForm = ({ onClose }: Props) => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");

  function openMailClient() {
    const to = ""; // optional: fill in a default email address
    const s = encodeURIComponent(subject || "Website Contact");
    const body = encodeURIComponent(
      [
        name ? `Name: ${name}` : "",
        email ? `Email: ${email}` : "",
        "",
        message || "",
      ]
        .filter(Boolean)
        .join("\n")
    );
    const mailto = `mailto:${to}?subject=${s}&body=${body}`;
    window.location.href = mailto;
  }

  return (
    <section className="contact-wrap" aria-label="Contact form">
      <header className="contact-header">
        <h2>Contact</h2>
        <button className="btn" onClick={onClose} aria-label="Back to blog">
          ← Back
        </button>
      </header>

      <form
        className="contact-form"
        onSubmit={(e) => {
          e.preventDefault();
          openMailClient();
        }}
      >
        <label className="cf-label" htmlFor="cf-name">
          Name
        </label>
        <input
          id="cf-name"
          className="cf-input"
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="Your name"
        />

        <label className="cf-label" htmlFor="cf-email">
          Email
        </label>
        <input
          id="cf-email"
          className="cf-input"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="you@example.com"
          required
        />

        <label className="cf-label" htmlFor="cf-subject">
          Subject
        </label>
        <input
          id="cf-subject"
          className="cf-input"
          type="text"
          value={subject}
          onChange={(e) => setSubject(e.target.value)}
          placeholder="What’s this about?"
        />

        <label className="cf-label" htmlFor="cf-message">
          Message
        </label>
        <textarea
          id="cf-message"
          className="cf-textarea"
          rows={8}
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          placeholder="Write your message..."
          required
        />

        <div className="cf-actions">
          <button className="btn btn-primary" type="submit">
            Send
          </button>
          <button className="btn" type="button" onClick={onClose}>
            Cancel
          </button>
        </div>
      </form>

      <style>
        {`
          .contact-wrap {
            width: 100%;
            box-sizing: border-box;
            text-align: left; /* ensure left alignment inside centered app */
            padding-left: 20px; /* offset from left side */
          }
          .contact-header {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin: 0 0 12px;
          }
          .contact-header h2 {
            margin: 0;
          }
          .contact-form {
            display: grid;
            grid-template-columns: 1fr;
            gap: 8px;
            border: 6px solid #000;
            box-shadow: 10px 10px 0 #000;
            padding: 16px;
            background: #fff;
            width: 100%;
            box-sizing: border-box; /* include border + padding to avoid overflow */
            max-width: 660px; /* make form more narrow */
            /* Align left with the Contact heading */
            margin: 0;        /* no centering */
            margin-right: auto; /* keep narrow width but left-aligned */
          }
          .cf-label { font-weight: 800; text-align: left; }
          .cf-input, .cf-textarea {
            border: 3px solid #000;
            box-shadow: 4px 4px 0 #000;
            background: #fff;
            padding: 10px 12px;
            font-weight: 700;
            width: 100%;
            box-sizing: border-box;
          }
          .cf-textarea { resize: vertical; }
          .cf-actions { display: flex; gap: 8px; margin-top: 6px; }

          .btn {
            border: 3px solid #000;
            box-shadow: 3px 3px 0 #000;
            background: #fff;
            padding: 8px 12px;
            font-weight: 800;
            cursor: pointer;
          }
          .btn-primary { background: #fff; color: #000; }

          @media (max-width: 760px) {
            .contact-form {
              box-shadow: 6px 6px 0 #000;
              padding: 12px;
              max-width: 100%; /* never exceed viewport on small screens */
            }
          }
        `}
      </style>
    </section>
  );
};

export default ContactForm;
